import React, { useState, useRef, useEffect } from 'react';
import { cpGetAuthHeader } from './ClientPortalApp';
import Select2Dropdown from '../common/Select2Dropdown';

// ── Dropdown options ─────────────────────────────────────────────────────────

const PERMIT_REQUEST_TYPE_OPTIONS = [
    'MEDICINES NORMAL IMPORT PERMIT',
    'MEDICAL DEVICES NORMAL IMPORT PERMIT',
    'MEDICINES *SPECIAL* IMPORT PERMIT',
    'MEDICAL DEVICES *SPECIAL* IMPORT PERMIT',
    'MEDICINES RAW MATERIAL IMPORT PERMIT',
    'MEDICAL DEVICES RAW MATERIAL IMPORT PERMIT',
    'MEDICINES NORMAL EXPORT PERMIT',
    'MEDICAL DEVICES NORMAL EXPORT PERMIT',
    'MEDICINES *SPECIAL EXPORT* PERMIT',
    'MEDICAL DEVICES *SPECIAL EXPORT* PERMIT',
];

const CURRENCIES = ['TZS', 'USD'];

const PRODUCT_TYPES = ['MEDICINE', 'MEDICAL DEVICES'];

const NEW_USED_OPTIONS = ['NEW', 'USED'];

const UNIT_OF_MEASURE_OPTIONS = [
    'DPC	Dozen Pieces',
    'DPR	Dozen Pairs',
    'DZN	Dozen',
    'DZP	Dozen Packs',
    'LTR	Litre (1 Dm3)',
    'MGM	Milligram',
    'NRL    Number of Rolls',
    'NMB	Number',
    'PCE	Piece',
    'SET	Set'
];

const PACKAGE_TYPE_OPTIONS = [
    'PK	Package(S)',
    'BA	Barrel',
    'BE	Bundle',
    'BG	Bag',
    'BR	Bar',
    'BX	Box',
    'CN	Carton',
    'CO	Colli',
    'CS	Case',
    'CT	Crate',
    'CY	Cylinder',
    'DR	Drum',
    'GB	Gas Bottle',
    'NE	Unpacked Or Unpackaged',
    'PA	Packet',
    'PC	Parcel',
    'PG	Plate',
    'PS	Pieces',
    'PT	Pallets',
    'SA	Sack',
    'ST	Sheet',
    'SZ	Sheets (Bulk)',
    'TN	Tin',
    'TU	Tube'
];

const TMDA_PRODUCT_TYPE_OPTIONS = ['Medicine', 'Medical Devices'];

const MEDICAL_DEVICE_TYPE_OPTIONS = ['Medical Device', 'Invitro-Diagnosis'];

const PRODUCT_CLASSIFICATION_OPTIONS = [
    'Human Medicinal',
    'Veterinary Medicinal',
    'Herbal Medicinal',
    'Antiseptic/Disinfectant',
    'Biologicals Including Vaccines',
    'Veterinary Vaccines',
    'Class A',
    'Class B',
    'Class C',
    'Class D'
];

const HS_CODE_OPTIONS = [
    '3001.20.00',
    '3001.90.00',
    '3002.11.00',
    '3002.12.00',
    '3002.13.00',
    '3002.14.00',
    '3002.15.00',
    '3002.41.00',
    '3002.42.00',
    '3002.49.00',
    '3002.51.00',
    '3002.59.00',
    '3002.90.00',
    '3003.10.00',
    '3003.20.00',
    '3003.31.00',
    '3003.39.00',
    '3003.41.00',
    '3003.42.00',
    '3003.43.00',
    '3003.49.00',
    '3003.60.00',
    '3003.90.00',
    '3004.10.00',
    '3004.20.00',
    '3004.31.00',
    '3004.32.00',
    '3004.39.00',
    '3004.41.00',
    '3004.42.00',
    '3004.43.00',
    '3004.49.00',
    '3004.50.00',
    '3004.60.00',
    '3004.90.00',
    '3005.10.00',
    '3005.90.10',
    '3005.90.11',
    '3005.90.12',
    '3005.90.19',
    '3005.90.90',
    '3006.10.00',
    '3006.20.00',
    '3006.30.00',
    '3006.40.00',
    '3006.50.00',
    '3006.60.00',
    '3006.70.00',
    '3006.91.00',
    '3006.93.00',
    '3306.20.00',
    '3507.90.00',
    '3701.10.00',
    '3702.10.00',
    '3821.00.00',
    '3822.00.00',
    '3822.11.00',
    '3822.13.00',
    '3822.19.00',
    '3822.90.00',
    '3926.90.90',
    '4014.10.00',
    '4015.11.00',
    '4015.12.00',
    '6115.10.00',
    '6212.90.00',
    '6307.90.00',
    '6307.90.00',
    '6406.90.00',
    '7017.90.00',
    '8419.20.00',
    '8713.10.00',
    '8713.90.00',
    '9001.30.00',
    '9001.40.00',
    '9011.10.00',
    '9012.90.00',
    '9018.11.00',
    '9018.12.00',
    '9018.13.00',
    '9018.14.00',
    '9018.19.00',
    '9018.20.00',
    '9018.31.00',
    '9018.32.00',
    '9018.39.00',
    '9018.41.00',
    '9018.49.00',
    '9018.50.00',
    '9018.90.00',
    '9019.10.00',
    '9019.20.00',
    '9020.00.00',
    '9021.10.00',
    '9021.21.00',
    '9021.29.00',
    '9021.31.00',
    '9021.39.00',
    '9021.40.00',
    '9021.50.00',
    '9021.90.00',
    '9022.12.00',
    '9022.13.00',
    '9022.14.00',
    '9022.19.00',
    '9022.21.00',
    '9022.30.00',
    '9022.90.00',
    '9023.00.00',
    '9025.11.00',
    '9027.50.00',
    '9027.90.00',
    '9031.80.00',
    '9031.90.00',
    '9402.10.10',
    '9402.10.90',
    '9402.90.10',
    '9402.90.90',
    '9404.29.00',
    '9404.90.00',
    '9506.91.00',
    '9619.00.10',
    '9619.00.90'
];

const PERMIT_REASONS = [
    'FOR SALE',
    'CLINICAL RESEARCH',
    'DONATION',
    'FOR LABORATORY ANALYSIS',
    'FOR LABORATORY USE',
    'FOR PERSONAL USE',
    'GOVERNMENT USE',
    'HOSPITAL USE',
    'MANUFACTURING',
    'PROMOTIONAL MATERIAL',
    'SAMPLES FOR REGISTRATION',
];

const PERMIT_TYPES = [
    'NORMAL IMPORT PERMIT',
    'NORMAL EXPORT PERMIT',
    'SPECIAL IMPORT PERMIT',
    'SPECIAL EXPORT PERMIT',
    'RAW IMPORT PERMIT',
];

const PERMIT_CATEGORIES = [
    'IMPORTATION', 'CHARITY', 'CONSTRUCTION COMPANY', 'DENTAL CLINIC', 'DLDM',
    'DONATION', 'EXHIBITION', 'EXPIRED PRODUCTS', 'EXPORTATION', 'FOR PERSONAL USE',
    'GOVERNMENT HOSPITAL', 'GOVERNMENT INSTITUTION', 'INTERNATIONAL ORGANIZATION',
    'LABORATORY ANALYSIS', 'MANUFACTURING', 'MEDICAL DEVICES OUTLET', 'MINISTRY OF HEALTH',
    'NON-GOVERNMENTAL ORGANIZATION', 'PHARMACY', 'POST MARKETING SAMPLE', 'PRE-REGISTRATION',
    'PRIVATE HOSPITAL', 'PROHIBITED INGREDIENT', 'PROHIBITED PRODUCT', 'PROMOTIONAL MATERIAL',
    'QUALITY ANALYSIS', 'RAW MATERIAL', 'RELIGIOUS USE', 'RESEARCH', 'RETAIL PHARMACY',
    'RETAIL VETERINARY PHARMACY', 'SAMPLE FOR LABORATORY', 'SPECIAL USE', 'STUDY PURPOSE',
    'UNREGISTERED PRODUCT', 'VETERINARY CLINIC', 'VETERINARY PHARMACY', 'WAREHOUSE',
    'WHOLESALE AND RETAIL MEDICAL DEVICES', 'WHOLESALE MEDICAL DEVICES', 'WHOLESALE PHARMACY',
    'WHOLESALE VETERINARY PHARMACY', 'WHOLESALE AND RETAIL PHARMACY',
];

const TRANSPORT_MODES = ['SEA', 'AIR', 'ROAD'];

const PORT_OF_ENTRY_MAP = {
    AIR: ['TZDA (JNIA AIRPORT)'],
    SEA: ['TZDL (DSM SEA PORT)'],
    ROAD: ['TZNG (NAMANGA BORDER)', 
           'TZMK (MUTUKULA BORDER)',
           'TZTM (ZAMBIA BORDER)',
           'TZHO (HOROHORO BORDER)',
           'TZHL (HOLILI BORDER)']
};

// ── Helpers ──────────────────────────────────────────────────────────────────

const today = () => new Date().toISOString().slice(0, 10);

const ALLOWED_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];
const ALLOWED_EXT = ['.pdf', '.jpg', '.jpeg', '.png'];

const emptyProduct = () => ({
    id: Date.now() + Math.random(),
    // Common fields for both permit types
    hs_code: '',
    item_description: '',
    new_used: '',
    unit_of_measure: '',
    uom_quantity: '',
    package_type: '',
    package_type_quantity: '',
    total_item_net_weight: '',
    total_item_gross_weight: '',
    country_of_origin: '',
    item_total_fob_value: '',
    production_registration_number: '',
    // Special Import Permit only fields
    product_brand_name: '',
    product_generic_name: '',
    product_dosage_form: '',
    product_manufacturer: '',
    tmda_product_type: '',
    medical_device_type: '',
    product_classification: '',
    // Legacy fields (to be removed or mapped)
    product_name: '',
    strength: '',
    dosage_form: '',
    quantity: '',
    unit: '',
    unit_price: '',
    fob_value: '',
    net_weight: '',
    gross_weight: '',
    registration_no: '',
});

const fmt = (v) => {
    const n = parseFloat(v) || 0;
    return n.toFixed(2);
};

const sum = (rows, field) =>
    rows.reduce((acc, r) => acc + (parseFloat(r[field]) || 0), 0).toFixed(2);

// ── Field wrapper (module-level to avoid remount on re-render) ───────────────
const Field = ({ id, label, required, error, children }) => (
    <div className={`tmda-field${error ? ' tmda-field-error' : ''}`}>
        <label htmlFor={id} className="tmda-label">
            {label}{required && <span className="tmda-required"> *</span>}
        </label>
        {children}
        {error && <div className="tmda-error-msg">{error}</div>}
    </div>
);

// ── Component ────────────────────────────────────────────────────────────────

const ClientTmdaApplication = () => {
    const fileInputRef = useRef(null);

    const [form, setForm] = useState({
        submission_date: today(),
        client_name: '',
        exporter_name: '',
        permit_request_type: '',
        pfi_no: '',
        pfi_date: '',
        currency: '',
        product_type: '',
        permit_reason: '',
        permit_type: '',
        permit_category: '',
        business_permit_no: '',
        transport_mode: '',
        port_of_entry: '',
        email: '',
    });

    const [products, setProducts] = useState([emptyProduct()]);
    const [attachments, setAttachments] = useState([]);
    const [fileError, setFileError] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [errors, setErrors] = useState({});

    // Fetch logged-in customer name and auto-populate client_name
    useEffect(() => {
        fetch('/api/client/me/', { headers: cpGetAuthHeader() })
            .then(r => r.ok ? r.json() : null)
            .then(data => {
                if (data?.customer_name) {
                    setForm(f => ({ ...f, client_name: data.customer_name }));
                }
            })
            .catch(() => {});
    }, []);

    // Auto-set port of entry when transport mode changes
    useEffect(() => {
        const ports = PORT_OF_ENTRY_MAP[form.transport_mode] || [];
        // If there's only one option, auto-select it; otherwise leave it empty for user to select
        const port = ports.length === 1 ? ports[0] : '';
        setForm(f => ({ ...f, port_of_entry: port }));
    }, [form.transport_mode]);

    const setField = (field, value) =>
        setForm(f => ({ ...f, [field]: value }));

    // ── Products table ────────────────────────────────────────────────────────

    // Helper functions to determine permit type
    const isSpecialPermit = () => {
        return form.permit_request_type && form.permit_request_type.includes('SPECIAL');
    };

    const isMedicalDevices = () => {
        return form.permit_request_type && form.permit_request_type.includes('MEDICAL DEVICES');
    };

    const isMedicalDevicesSpecial = () => {
        return isSpecialPermit() && isMedicalDevices();
    };

    const updateProduct = (id, field, value) => {
        setProducts(rows =>
            rows.map(r => {
                if (r.id !== id) return r;
                const updated = { ...r, [field]: value };
                // Auto-calc fob_value = quantity * unit_price
                if (field === 'quantity' || field === 'unit_price') {
                    const qty = parseFloat(field === 'quantity' ? value : updated.quantity) || 0;
                    const price = parseFloat(field === 'unit_price' ? value : updated.unit_price) || 0;
                    updated.fob_value = qty > 0 && price > 0 ? (qty * price).toFixed(2) : updated.fob_value;
                }
                return updated;
            })
        );
    };

    const addProduct = () => setProducts(r => [...r, emptyProduct()]);
    const removeProduct = (id) => setProducts(r => r.filter(p => p.id !== id));

    const totalFob = sum(products, 'item_total_fob_value');
    const totalNet = sum(products, 'total_item_net_weight');
    const totalGross = sum(products, 'total_item_gross_weight');

    // ── File upload ───────────────────────────────────────────────────────────

    const handleFiles = (files) => {
        setFileError('');
        const valid = [];
        for (const f of files) {
            const ext = f.name.toLowerCase().slice(f.name.lastIndexOf('.'));
            if (!ALLOWED_TYPES.includes(f.type) && !ALLOWED_EXT.includes(ext)) {
                setFileError(`"${f.name}" is not allowed. Only PDF, JPG, PNG are accepted.`);
                continue;
            }
            valid.push(f);
        }
        setAttachments(prev => [...prev, ...valid]);
    };

    const handleFileInput = (e) => {
        handleFiles(Array.from(e.target.files));
        e.target.value = '';
    };

    const handleDrop = (e) => {
        e.preventDefault();
        handleFiles(Array.from(e.dataTransfer.files));
    };

    const removeAttachment = (idx) =>
        setAttachments(prev => prev.filter((_, i) => i !== idx));

    // ── Validation ────────────────────────────────────────────────────────────

    const REQUIRED_FIELDS = [
        ['submission_date', 'Submission Date'],
        ['exporter_name', 'Exporter/Manufacturer Name'],
        ['permit_request_type', 'Permit Request Type'],
        ['pfi_no', 'Proforma/Invoice No.'],
        ['pfi_date', 'PFI Date'],
        ['currency', 'TMDA Bill Currency'],
        ['product_type', 'TMDA Permit Product Type'],
        ['permit_reason', 'Permit Reason'],
        ['permit_type', 'Permit Type'],
        ['permit_category', 'Permit Category'],
        ['business_permit_no', 'Premises Business Permit No.'],
        ['transport_mode', 'Mode of Transport'],
        ['email', 'Email Address'],
    ];

    const validate = () => {
        const errs = {};
        for (const [k, label] of REQUIRED_FIELDS) {
            if (!form[k] || !form[k].toString().trim()) {
                errs[k] = `${label} is required.`;
            }
        }
        if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
            errs.email = 'Please enter a valid email address.';
        }
        if (attachments.length === 0) {
            errs.attachments = 'Please attach at least one document (PFI/INV or TMDA Permit).';
        }
        return errs;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const errs = validate();
        setErrors(errs);
        if (Object.keys(errs).length > 0) {
            // Scroll to first error
            const firstKey = Object.keys(errs)[0];
            const el = document.getElementById(`tmda-${firstKey}`);
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
        }
        // Frontend-only: just show success state (backend not yet built)
        setSubmitted(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleReset = () => {
        setForm({
            submission_date: today(),
            client_name: '',
            exporter_name: '',
            permit_request_type: '',
            pfi_no: '',
            pfi_date: '',
            currency: '',
            product_type: '',
            permit_reason: '',
            permit_type: '',
            permit_category: '',
            business_permit_no: '',
            transport_mode: '',
            port_of_entry: '',
            email: '',
        });
        setProducts([emptyProduct()]);
        setAttachments([]);
        setErrors({});
        setFileError('');
        setSubmitted(false);
    };

    // ── Render helpers ────────────────────────────────────────────────────────

    const inputCls = (key) => `tmda-input${errors[key] ? ' error' : ''}`;

    // ── Success screen ────────────────────────────────────────────────────────

    if (submitted) {
        return (
            <>
                <div className="cp-page-header">
                    <h2>TMDA Permit Application</h2>
                </div>
                <div className="cp-card" style={{ textAlign: 'center', padding: '48px 32px' }}>
                    <i className="fa-solid fa-circle-check" style={{ fontSize: '3rem', color: '#22c55e', marginBottom: 16 }}></i>
                    <h3 style={{ margin: '0 0 8px', color: '#1e293b' }}>Application Submitted</h3>
                    <p style={{ color: '#64748b', marginBottom: 24 }}>
                        Your TMDA permit application has been received and will be processed by K&amp;K Company Ltd.
                        You will be contacted at <strong>{form.email}</strong> with further updates.
                    </p>
                    <button className="cp-btn cp-btn-primary" onClick={handleReset}>
                        <i className="fa-solid fa-plus"></i> Submit Another Application
                    </button>
                </div>
            </>
        );
    }

    // ── Main form ─────────────────────────────────────────────────────────────

    return (
        <>
            <div className="cp-page-header">
                <h2>TMDA Permit Application</h2>
            </div>

            {/* Disclaimer */}
            <div className="tmda-disclaimer">
                <i className="fa-solid fa-circle-info tmda-disclaimer-icon"></i>
                <div>
                    <strong>Disclaimer:</strong> This portal is provided by K AND K COMPANY LTD solely to assist clients in
                    submitting permit application information accurately and efficiently for processing through the relevant
                    government systems, including TANeSW/TMDA. Submission of information through this portal does not
                    constitute approval, issuance, or direct submission of permits by the authorities. Clients are responsible
                    for ensuring that all submitted information and supporting documents are accurate and complete.
                </div>
            </div>

            <form onSubmit={handleSubmit} noValidate>

                {/* ── Section 1: Basic Info ── */}
                <div className="cp-card tmda-section">
                    <div className="tmda-section-title">
                        <i className="fa-solid fa-file-lines"></i> Application Details
                    </div>

                    <div className="tmda-grid tmda-grid-3">
                        <Field id="tmda-submission_date" label="Submission Date" required error={errors.submission_date}>
                            <input
                                id="tmda-submission_date"
                                type="date"
                                className={inputCls('submission_date')}
                                value={form.submission_date}
                                onChange={e => setField('submission_date', e.target.value)}
                            />
                        </Field>

                        <Field id="tmda-client_name" label="Client / Importer Name" required error={errors.client_name}>
                            <input
                                id="tmda-client_name"
                                type="text"
                                className="tmda-input tmda-input-readonly"
                                value={form.client_name}
                                readOnly
                                tabIndex={-1}
                                placeholder="Loading..."
                            />
                        </Field>

                        <Field id="tmda-exporter_name" label="Exporter / Manufacturer Name" required error={errors.exporter_name}>
                            <input
                                id="tmda-exporter_name"
                                type="text"
                                className={inputCls('exporter_name')}
                                placeholder="Enter exporter or manufacturer name"
                                value={form.exporter_name}
                                onChange={e => setField('exporter_name', e.target.value)}
                            />
                        </Field>

                        <Field id="tmda-permit_request_type" label="Permit Request Type" required error={errors.permit_request_type}>
                            <Select2Dropdown
                                options={PERMIT_REQUEST_TYPE_OPTIONS}
                                value={form.permit_request_type}
                                onChange={v => setField('permit_request_type', v)}
                                placeholder="Select Permit Request Type"
                                className={errors.permit_request_type ? 'tmda-select-error' : ''}
                                menuPlacement="auto"
                            />
                        </Field>

                        <Field id="tmda-pfi_no" label="Proforma / Invoice No." required error={errors.pfi_no}>
                            <input
                                id="tmda-pfi_no"
                                type="text"
                                className={inputCls('pfi_no')}
                                placeholder="Enter PFI or Invoice number"
                                value={form.pfi_no}
                                onChange={e => setField('pfi_no', e.target.value)}
                            />
                        </Field>

                        <Field id="tmda-pfi_date" label="PFI Date" required error={errors.pfi_date}>
                            <input
                                id="tmda-pfi_date"
                                type="date"
                                className={inputCls('pfi_date')}
                                value={form.pfi_date}
                                onChange={e => setField('pfi_date', e.target.value)}
                            />
                        </Field>

                        <Field id="tmda-currency" label="TMDA Bill Currency" required error={errors.currency}>
                            <Select2Dropdown
                                options={CURRENCIES}
                                value={form.currency}
                                onChange={v => setField('currency', v)}
                                placeholder="Select Currency"
                                className={errors.currency ? 'tmda-select-error' : ''}
                                searchable={false}
                                menuPlacement="auto"
                            />
                            {form.currency && (
                                <div className="tmda-hint">Select which currency you want to pay the TMDA bill</div>
                            )}
                        </Field>

                        <Field id="tmda-product_type" label="TMDA Permit Product Type" required error={errors.product_type}>
                            <Select2Dropdown
                                options={PRODUCT_TYPES}
                                value={form.product_type}
                                onChange={v => setField('product_type', v)}
                                placeholder="Select Product Type"
                                className={errors.product_type ? 'tmda-select-error' : ''}
                                searchable={false}
                                menuPlacement="auto"
                            />
                        </Field>

                        <Field id="tmda-permit_reason" label="Permit Reason" required error={errors.permit_reason}>
                            <Select2Dropdown
                                options={PERMIT_REASONS}
                                value={form.permit_reason}
                                onChange={v => setField('permit_reason', v)}
                                placeholder="Select Permit Reason"
                                className={errors.permit_reason ? 'tmda-select-error' : ''}
                                menuPlacement="auto"
                            />
                        </Field>

                        <Field id="tmda-permit_type" label="Permit Type" required error={errors.permit_type}>
                            <Select2Dropdown
                                options={PERMIT_TYPES}
                                value={form.permit_type}
                                onChange={v => setField('permit_type', v)}
                                placeholder="Select Permit Type"
                                className={errors.permit_type ? 'tmda-select-error' : ''}
                                menuPlacement="auto"
                            />
                        </Field>

                        <Field id="tmda-permit_category" label="Permit Category" required error={errors.permit_category}>
                            <Select2Dropdown
                                options={PERMIT_CATEGORIES}
                                value={form.permit_category}
                                onChange={v => setField('permit_category', v)}
                                placeholder="Select Permit Category"
                                className={errors.permit_category ? 'tmda-select-error' : ''}
                                menuPlacement="auto"
                            />
                        </Field>

                        <Field id="tmda-business_permit_no" label="Premises Business Permit No." required error={errors.business_permit_no}>
                            <input
                                id="tmda-business_permit_no"
                                type="text"
                                className={inputCls('business_permit_no')}
                                placeholder="Enter business permit number"
                                value={form.business_permit_no}
                                onChange={e => setField('business_permit_no', e.target.value)}
                            />
                        </Field>
                    </div>
                </div>

                {/* ── Section 2: Transport ── */}
                <div className="cp-card tmda-section">
                    <div className="tmda-section-title">
                        <i className="fa-solid fa-ship"></i> Transport Details
                    </div>

                    <div className="tmda-grid tmda-grid-3">
                        <Field id="tmda-transport_mode" label="Mode of Transport" required error={errors.transport_mode}>
                            <Select2Dropdown
                                options={TRANSPORT_MODES}
                                value={form.transport_mode}
                                onChange={v => setField('transport_mode', v)}
                                placeholder="Select Mode of Transport"
                                className={errors.transport_mode ? 'tmda-select-error' : ''}
                                searchable={false}
                                menuPlacement="auto"
                            />
                        </Field>

                        <Field id="tmda-port_of_entry" label="Port of Entry">
                            <Select2Dropdown
                                options={PORT_OF_ENTRY_MAP[form.transport_mode] || []}
                                value={form.port_of_entry}
                                onChange={v => setField('port_of_entry', v)}
                                placeholder="Select Port of Entry"
                                menuPlacement="auto"
                            />
                        </Field>
                    </div>
                </div>

                {/* ── Section 3: Products ── */}
                <div className="cp-card tmda-section">
                    <div className="tmda-section-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span><i className="fa-solid fa-pills"></i> Products / Items</span>
                        <button type="button" className="cp-btn cp-btn-primary tmda-btn-sm" onClick={addProduct}>
                            <i className="fa-solid fa-plus"></i> Add Product
                        </button>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                        {products.map((p, idx) => (
                            <div key={p.id} className="cp-card" style={{ padding: 16, border: '1px solid #e2e8f0', borderRadius: 8 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                    <span style={{ fontWeight: 600, color: '#475569' }}>Item #{idx + 1}</span>
                                    {products.length > 1 && (
                                        <button
                                            type="button"
                                            className="cp-btn-icon"
                                            title="Remove item"
                                            onClick={() => removeProduct(p.id)}
                                            style={{ color: '#ef4444' }}
                                        >
                                            <i className="fa-solid fa-trash"></i>
                                        </button>
                                    )}
                                </div>

                                {/* Row 1: HS Code, Item Description, New/Used, Unit of Measure, UOM Quantity, Package Type */}
                                <div className="tmda-grid tmda-grid-6">
                                    <div>
                                        <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                            HS Code <span className="tmda-required">*</span>
                                        </label>
                                        <Select2Dropdown
                                            options={HS_CODE_OPTIONS}
                                            value={p.hs_code}
                                            onChange={v => updateProduct(p.id, 'hs_code', v)}
                                            placeholder="Select HS Code"
                                            menuPlacement="auto"
                                        />
                                        <div style={{ fontSize: 10, color: '#666', marginTop: 2 }}>
                                            Check previous assessment to get HS Code
                                        </div>
                                    </div>
                                    <div>
                                        <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                            Item Description <span className="tmda-required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="tmda-input"
                                            placeholder="Item description"
                                            value={p.item_description}
                                            onChange={e => updateProduct(p.id, 'item_description', e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                            New/Used <span className="tmda-required">*</span>
                                        </label>
                                        <Select2Dropdown
                                            options={NEW_USED_OPTIONS}
                                            value={p.new_used}
                                            onChange={v => updateProduct(p.id, 'new_used', v)}
                                            placeholder="Select"
                                            menuPlacement="auto"
                                        />
                                    </div>
                                    <div>
                                        <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                            Unit of Measure <span className="tmda-required">*</span>
                                        </label>
                                        <Select2Dropdown
                                            options={UNIT_OF_MEASURE_OPTIONS}
                                            value={p.unit_of_measure}
                                            onChange={v => updateProduct(p.id, 'unit_of_measure', v)}
                                            placeholder="Select"
                                            menuPlacement="auto"
                                        />
                                    </div>
                                    <div>
                                        <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                            UOM Quantity <span className="tmda-required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            className="tmda-input"
                                            placeholder="0"
                                            min="0"
                                            value={p.uom_quantity}
                                            onChange={e => updateProduct(p.id, 'uom_quantity', e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                            Package Type <span className="tmda-required">*</span>
                                        </label>
                                        <Select2Dropdown
                                            options={PACKAGE_TYPE_OPTIONS}
                                            value={p.package_type}
                                            onChange={v => updateProduct(p.id, 'package_type', v)}
                                            placeholder="Select"
                                            menuPlacement="auto"
                                        />
                                    </div>
                                </div>

                                {/* Row 2: Package Type Quantity, Total Item Net Weight, Total Item Gross Weight, Country of Origin, Item Total FOB Value, Production Registration Number */}
                                <div className="tmda-grid tmda-grid-6" style={{ marginTop: 12 }}>
                                    <div>
                                        <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                            Package Type Quantity <span className="tmda-required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            className="tmda-input"
                                            placeholder="0"
                                            min="0"
                                            value={p.package_type_quantity}
                                            onChange={e => updateProduct(p.id, 'package_type_quantity', e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                            Total Item Net Weight (kg) <span className="tmda-required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            className="tmda-input"
                                            placeholder="0.00"
                                            min="0"
                                            step="0.01"
                                            value={p.total_item_net_weight}
                                            onChange={e => updateProduct(p.id, 'total_item_net_weight', e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                            Total Item Gross Weight (kg) <span className="tmda-required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            className="tmda-input"
                                            placeholder="0.00"
                                            min="0"
                                            step="0.01"
                                            value={p.total_item_gross_weight}
                                            onChange={e => updateProduct(p.id, 'total_item_gross_weight', e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                            Country of Origin <span className="tmda-required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="tmda-input"
                                            placeholder="Country"
                                            value={p.country_of_origin}
                                            onChange={e => updateProduct(p.id, 'country_of_origin', e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                            Item Total FOB Value ({form.currency || '—'}) <span className="tmda-required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            className="tmda-input"
                                            placeholder="0.00"
                                            min="0"
                                            step="0.01"
                                            value={p.item_total_fob_value}
                                            onChange={e => updateProduct(p.id, 'item_total_fob_value', e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                            Production Registration Number <span className="tmda-required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="tmda-input"
                                            placeholder="Reg. No."
                                            value={p.production_registration_number}
                                            onChange={e => updateProduct(p.id, 'production_registration_number', e.target.value)}
                                        />
                                    </div>
                                </div>

                                {/* Special Permit Fields */}
                                {isSpecialPermit() && (
                                    <>
                                        {/* Row 3: Product Brand Name, Product Generic Name, Product Dosage Form, Product Manufacturer, TMDA Product Type, Product Classification */}
                                        <div className="tmda-grid tmda-grid-6" style={{ marginTop: 12 }}>
                                            <div>
                                                <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                                    Product Brand Name <span className="tmda-required">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="tmda-input"
                                                    placeholder="Brand name"
                                                    value={p.product_brand_name}
                                                    onChange={e => updateProduct(p.id, 'product_brand_name', e.target.value)}
                                                />
                                            </div>
                                            <div>
                                                <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                                    Product Generic Name <span className="tmda-required">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="tmda-input"
                                                    placeholder="Generic name"
                                                    value={p.product_generic_name}
                                                    onChange={e => updateProduct(p.id, 'product_generic_name', e.target.value)}
                                                />
                                            </div>
                                            <div>
                                                <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                                    Product Dosage Form <span className="tmda-required">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="tmda-input"
                                                    placeholder="Dosage form"
                                                    value={p.product_dosage_form}
                                                    onChange={e => updateProduct(p.id, 'product_dosage_form', e.target.value)}
                                                />
                                            </div>
                                            <div>
                                                <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                                    Product Manufacturer <span className="tmda-required">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="tmda-input"
                                                    placeholder="Manufacturer"
                                                    value={p.product_manufacturer}
                                                    onChange={e => updateProduct(p.id, 'product_manufacturer', e.target.value)}
                                                />
                                            </div>
                                            <div>
                                                <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                                    TMDA Product Type <span className="tmda-required">*</span>
                                                </label>
                                                <Select2Dropdown
                                                    options={TMDA_PRODUCT_TYPE_OPTIONS}
                                                    value={p.tmda_product_type}
                                                    onChange={v => updateProduct(p.id, 'tmda_product_type', v)}
                                                    placeholder="Select"
                                                    menuPlacement="auto"
                                                />
                                            </div>
                                            <div>
                                                <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                                    Product Classification <span className="tmda-required">*</span>
                                                </label>
                                                <Select2Dropdown
                                                    options={PRODUCT_CLASSIFICATION_OPTIONS}
                                                    value={p.product_classification}
                                                    onChange={v => updateProduct(p.id, 'product_classification', v)}
                                                    placeholder="Select"
                                                    menuPlacement="auto"
                                                />
                                            </div>
                                        </div>

                                        {/* Row 4: Medical Device Type (only for Medical Devices Special Import Permit) */}
                                        {isMedicalDevicesSpecial() && (
                                            <div className="tmda-grid tmda-grid-6" style={{ marginTop: 12 }}>
                                                <div>
                                                    <label style={{ fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 4, display: 'block' }}>
                                                        Medical Device Type <span className="tmda-required">*</span>
                                                    </label>
                                                    <Select2Dropdown
                                                        options={MEDICAL_DEVICE_TYPE_OPTIONS}
                                                        value={p.medical_device_type}
                                                        onChange={v => updateProduct(p.id, 'medical_device_type', v)}
                                                        placeholder="Select"
                                                        menuPlacement="auto"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        ))}
                    </div>

                    {/* Totals summary cards */}
                    <div className="tmda-totals-summary">
                        <div className="tmda-total-card">
                            <div className="tmda-total-card-label">Total FOB Value ({form.currency || ''})</div>
                            <div className="tmda-total-card-value">{totalFob}</div>
                        </div>
                        <div className="tmda-total-card">
                            <div className="tmda-total-card-label">Total Net Weight (kg)</div>
                            <div className="tmda-total-card-value">{totalNet}</div>
                        </div>
                        <div className="tmda-total-card">
                            <div className="tmda-total-card-label">Total Gross Weight (kg)</div>
                            <div className="tmda-total-card-value">{totalGross}</div>
                        </div>
                    </div>
                </div>

                {/* ── Section 4: Attachments ── */}
                <div className="cp-card tmda-section">
                    <div className="tmda-section-title">
                        <i className="fa-solid fa-paperclip"></i> Attachments
                    </div>
                    <p className="tmda-hint" style={{ marginBottom: 12 }}>
                        Attach PFI/Invoice &amp; TMDA Permit (if available). Only PDF, JPG, PNG formats accepted.
                        You can attach more than one document.
                    </p>

                    {/* Drop zone */}
                    <div
                        className={`tmda-dropzone${errors.attachments ? ' error' : ''}`}
                        onClick={() => fileInputRef.current.click()}
                        onDragOver={e => e.preventDefault()}
                        onDrop={handleDrop}
                    >
                        <i className="fa-solid fa-cloud-arrow-up tmda-dropzone-icon"></i>
                        <div className="tmda-dropzone-text">
                            <strong>Click to browse</strong> or drag &amp; drop files here
                        </div>
                        <div className="tmda-dropzone-sub">PDF, JPG, PNG only</div>
                    </div>
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                        multiple
                        style={{ display: 'none' }}
                        onChange={handleFileInput}
                    />

                    {fileError && <div className="tmda-error-msg" style={{ marginTop: 6 }}>{fileError}</div>}
                    {errors.attachments && <div className="tmda-error-msg" style={{ marginTop: 6 }}>{errors.attachments}</div>}

                    {attachments.length > 0 && (
                        <div className="tmda-file-list">
                            {attachments.map((f, i) => (
                                <div key={i} className="tmda-file-item">
                                    <i className={`fa-solid ${f.type === 'application/pdf' ? 'fa-file-pdf' : 'fa-file-image'} tmda-file-icon`}></i>
                                    <span className="tmda-file-name">{f.name}</span>
                                    <span className="tmda-file-size">({(f.size / 1024).toFixed(0)} KB)</span>
                                    <button
                                        type="button"
                                        className="cp-btn-icon"
                                        title="Remove"
                                        onClick={() => removeAttachment(i)}
                                        style={{ color: '#ef4444', marginLeft: 'auto' }}
                                    >
                                        <i className="fa-solid fa-xmark"></i>
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* ── Submit ── */}
                <div className="cp-card tmda-submit-bar">
                    <button type="button" className="cp-btn cp-btn-secondary" onClick={handleReset}>
                        <i className="fa-solid fa-rotate-left"></i> Reset Form
                    </button>
                    <button type="submit" className="cp-btn cp-btn-primary">
                        <i className="fa-solid fa-paper-plane"></i> Submit Application
                    </button>
                </div>

            </form>
        </>
    );
};

export default ClientTmdaApplication;
